/**
 * st-pdp-services.js — ST 2026-10-19 (Wrike 4586442589, Argus 2 for Ali)
 *
 * Service checkboxes of the PDP (snippets/st-pdp-services.liquid, design variant A). Montage ticked → Aufstellort
 * ticked, locked and "inklusive" (one service: aufbau); unticked → Aufstellort gets its previous state back.
 * selection(variantId) is read by ProductForm.prepareFormData (assets/theme.js) and st-buy-total (assets/st-buy-total.js):
 * { code, variant, price, sku } of the chosen service, or null (nothing ticked, block hidden in the control group of the
 * test, or the variant has no SKU). Changes fire "st-services:change" on the product form.
 * Round 3 (Ali 20.10.2026): the (i) buttons open the theme's <drawer-element> (snippets/st-pdp-services-info), no JS here.
 */

if (!customElements.get("st-pdp-services")) {
  customElements.define(
    "st-pdp-services",
    class StPdpServices extends HTMLElement {
      connectedCallback() {
        this.wunschort = this.querySelector('[data-st-svc="2mh"]');
        this.aufbau = this.querySelector('[data-st-svc="aufbau"]');
        this.wunschortBefore = false;
        try {
          this.skus = Object.fromEntries(JSON.parse(this.dataset.skus || "[]"));
        } catch (error) {
          this.skus = {};
        }
        this.onChange = this.onChange.bind(this);
        this.addEventListener("change", this.onChange);
        // Back/forward cache and form restore can bring a ticked Montage back: apply the lock again.
        if (this.aufbau?.checked) this.lockWunschort(true);
      }

      disconnectedCallback() {
        this.removeEventListener("change", this.onChange);
      }

      get form() {
        return document.getElementById(this.getAttribute("form"));
      }

      // Hidden (test mode, control group) = not part of the purchase.
      get active() {
        return this.getClientRects().length > 0;
      }

      selection(variantId) {
        if (!this.active) return null;
        const sku = this.skus[String(variantId)];
        if (!sku) return null;
        let input = null;
        if (this.aufbau?.checked) input = this.aufbau;
        else if (this.wunschort?.checked) input = this.wunschort;
        if (!input) return null;
        return {
          code: input.dataset.stSvc,
          variant: Number(input.dataset.variant),
          price: parseInt(input.dataset.price, 10) || 0,
          sku,
        };
      }

      lockWunschort(locked) {
        if (!this.wunschort) return;
        const row = this.wunschort.closest(".st-svc-pdp__row");
        if (locked) {
          if (!this.wunschort.disabled)
            this.wunschortBefore = this.wunschort.checked;
          this.wunschort.checked = true;
        } else if (this.wunschort.disabled) {
          this.wunschort.checked = this.wunschortBefore;
        }
        this.wunschort.disabled = locked;
        row.toggleAttribute("data-included", locked);
        row.querySelector("[data-st-svc-price]").hidden = locked;
        row.querySelector("[data-st-svc-included]").hidden = !locked;
      }

      onChange(event) {
        if (!event.target.matches("input[data-st-svc]")) return;
        event.stopPropagation();
        if (event.target === this.aufbau)
          this.lockWunschort(this.aufbau.checked);
        (this.form || document).dispatchEvent(
          new CustomEvent("st-services:change", { bubbles: true }),
        );
      }
    },
  );
}
